import * as React from "react";
import { differenceInHours } from "date-fns";
import { casesActions } from "configs";
import {
  useSelector,
  useDispatch,
  useOnline,
  getCaseImageIds,
  deleteImagesFromCache,
  clearStaleImagesFromCache
} from "duck";

const CacheManager: React.FC = () => {
  const online = useOnline();
  const dispatch = useDispatch();
  const casesState = useSelector(state => state.cases);

  React.useEffect(() => {
    if (!online) {
      return;
    }

    const dateNow = new Date();

    const allCases = Object.values(casesState);
    let staleCaseIds: number[] = [];
    let staleImageIds: number[] = [];

    allCases.forEach(medicalCase => {
      const {
        status,
        data: { createdAt, _id }
      } = medicalCase;

      if (
        status === "normal" &&
        (!createdAt || differenceInHours(dateNow, new Date(createdAt)) > 24)
      ) {
        staleCaseIds = [...staleCaseIds, _id];
        staleImageIds = [
          ...staleImageIds,
          ...getCaseImageIds(medicalCase.data)
        ];
      }
    });

    dispatch(casesActions.deleteCases(staleCaseIds));
    if (staleImageIds.length > 0) {
      deleteImagesFromCache(staleImageIds);
    }

    /* Prevent storage overflow */
    clearStaleImagesFromCache();
  }, []);

  return null;
};

export default CacheManager;
